import { useEffect, useState } from 'react';
import { registerNamespace, i18n } from '../i18n/bootstrap.js';

/**
 * Loads the People & Access translations into the shell's i18n: `{ ready, failed }`. Both embeds
 * of the package (the app and the public invitation link) need them before rendering anything.
 */
export const usePeopleAccessI18n = () => {
  const [state, setState] = useState({ ready: false, failed: false });

  useEffect(() => {
    let cancelled = false;
    import('@aimsos/people-access/i18n/register')
      .then(({ registerPeopleAccessI18n }) => {
        registerPeopleAccessI18n(registerNamespace);
        return i18n.loadNamespaces('people-access');
      })
      .then(() => {
        if (!cancelled) setState({ ready: true, failed: false });
      })
      .catch((err) => {
        console.error('[People & Access] i18n:', err);
        if (!cancelled) setState({ ready: false, failed: true });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};
